<template>
  <section class="loading-content">
    <slot></slot>
  </section>
</template>

<script>
// import lineItem from '@/components/public/loading/lineItem'
export default {
  name: "contentLoading",
  data() {
    return {};
  }
};
</script>

<style lang="scss">
@keyframes placeHolderSpinner {
  0% {
    background-position: -400px 0;
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    background-position: 400px 0;
    opacity: 1;
  }
}

.loading-content {
  width: 100%;
  height: 100%;
  min-width: 40px;
  .flex {
    width: 100%;
  }
  div:before,
  div:after {
    display: none !important;
  }
  .item-loading,
  .line,
  .block {
    animation-duration: 1.4s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: placeHolderSpinner;
    background-color: rgba(150, 150, 150, 0.1);
    background-image: linear-gradient(
      to right,
      transparent 5%,
      rgba(150, 150, 150, 0.2) 25%,
      transparent 50%
    ) !important;
    background-size: 800px;
    position: relative;
    border-radius: 2px;
    text-align: center;
    &.chart {
      background: transparent !important;
    }
  }

  $i: 5;
  @while $i < 100 {
    div.w#{$i} {
      width: $i * 1%;
    }
    .mtop#{$i} {
      margin-top: $i * 1px;
    }
    $i: $i + 5;
  }

  .spacer {
    width: 5px;
    height: 5px;
    display: inline-block;
  }
  .line {
    width: 100%;
    height: 15px;
    border-radius: 4px;
  }
}
</style>
